export default {
  GA: 'UA-100101606-20',
  API_URL: process.env.VUE_APP_API_URL,
  BROADCAST_URL: process.env.VUE_APP_API_URL + '/broadcasting/auth',
  PUSHER_KEY: '03679C7F0',
  PUSHER_HOST: 'ws.flooringtechnology.com.au',
  FACEBOOK_CLIENT_ID: 282091772491274,
  GOOGLE_CLIENT_ID: '194354700360-gvu29btko5n4t8ghrg7s0l1pd6gkh31u.apps.googleusercontent.com',
  LOGROCKET_ID: 'bhpmm1/digido'
};
